<i (click)="onClick()" [ngClass]="[iconClass, 'icon-button', disabled ? 'icon-button--disabled' : '']"></i>
